import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.003 2c-.335 0-.671.115-.93.345L1.33 11.051c-.513.459-.42 1.02.227 1.261l2.5.93.51 7.497c.048.692.628 1.255 1.32 1.256L9.52 22h.001c.681 0 1.258-.565 1.258-1.24v-5.654c0-.338.24-.606.598-.606h1.222a.62.62 0 0 1 .624.607v5.654c0 .684.543 1.239 1.225 1.239h3.68c.677 0 1.265-.547 1.317-1.255l.535-7.503 2.474-.93c.633-.237.732-.8.216-1.26l-9.737-8.707a1.391 1.391 0 0 0-.93-.345z"
});

var SvgHomeFilled = function SvgHomeFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgHomeFilled;